export default __webpack_public_path__ + "static/media/browserling.a620940d.svg";